
import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, Hotel, Store, Utensils } from 'lucide-react';

interface PlaceItem {
  id: string;
  name: string | null;
  place_type: string | null;
}

interface PlaylistCardContentProps {
  placeItems?: PlaceItem[];
  canEdit: boolean;
  isAuthenticated: boolean;
  onAddPlace: (e: React.MouseEvent) => void;
}

export const PlaylistCardContent: React.FC<PlaylistCardContentProps> = ({
  placeItems = [],
  canEdit,
  isAuthenticated,
  onAddPlace,
}) => {
  const getPlaceIcon = (type: string | null) => {
    switch (type) {
      case 'hotel':
        return <Hotel className="w-4 h-4" />;
      case 'shop':
        return <Store className="w-4 h-4" />;
      case 'restaurant':
        return <Utensils className="w-4 h-4" />;
      default:
        return null;
    }
  };

  return (
    <CardContent>
      <div className="space-y-4">
        {placeItems && placeItems.length > 0 ? (
          <div className="space-y-2">
            {placeItems.slice(0, 3).map((place) => (
              <div
                key={place.id}
                className="flex items-center gap-2 text-sm p-2 rounded-md bg-secondary/50"
              >
                {getPlaceIcon(place.place_type)}
                <span>{place.name}</span>
              </div>
            ))}
            {placeItems.length > 3 && (
              <div className="text-sm text-muted-foreground text-center">
                +{placeItems.length - 3} more places
              </div>
            )}
          </div>
        ) : null}
        
        {canEdit && isAuthenticated && (
          <Button
            variant="outline"
            className="w-full"
            onClick={onAddPlace}
          >
            <Plus className="w-4 h-4 mr-2" />
            Add Place
          </Button>
        )}
      </div>
    </CardContent>
  );
};
